const listItems = [
    {
        depth: 0,
        children: []
    },{
        title: 'Chapter 1: Preamble',
        depth: 1,
        parentIndex: 0,
        children: [2,5],
        disabled: false
    },{
        title: 'What is Functional Programming',
        depth: 2,
        children: [3,4],
        parentIndex: 1,
        disabled: false
    },{
        title: 'Pure Functions',
        depth: 3,
        parentIndex: 2,
        disabled: false,
        content: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec mattis pretium massa. Aliquam erat volutpat. Nulla facilisi. Donec vulputate interdum sollicitudin. Nunc lacinia auctor quam sed pellentesque. Aliquam dui mauris, mattis quis lacus id, pellentesque lobortis odio.',
    },{
        title: 'Composing Functions',
        depth: 3,
        parentIndex: 2,
        disabled: false,
        content: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec mattis pretium massa. Aliquam erat volutpat. Nulla facilisi. Donec vulputate interdum sollicitudin. Nunc lacinia auctor quam sed pellentesque. Aliquam dui mauris, mattis quis lacus id, pellentesque lobortis odio.',
    },{
        title: 'Functional JavaScript',
        depth: 2,
        children: [6,7],
        disabled: false,
        parentIndex: 1
    },{
        title: 'JavaScript Array Methods',
        depth: 3,
        parentIndex: 5,
        disabled: false,
        content: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec mattis pretium massa. Aliquam erat volutpat. Nulla facilisi. Donec vulputate interdum sollicitudin. Nunc lacinia auctor quam sed pellentesque. Aliquam dui mauris, mattis quis lacus id, pellentesque lobortis odio.',
    },{
        title: 'Introduction to Ramda',
        depth: 3,
        parentIndex: 5,
        disabled: false,
        content: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec mattis pretium massa. Aliquam erat volutpat. Nulla facilisi. Donec vulputate interdum sollicitudin. Nunc lacinia auctor quam sed pellentesque. Aliquam dui mauris, mattis quis lacus id, pellentesque lobortis odio.',
    },{
        title: 'Chapter 2: React',
        depth: 1,
        parentIndex: 0,
        disabled: false,
        children: [9,12]
    },{
        title: 'Introduction to React',
        depth: 2,
        parentIndex: 8,
        disabled: false,
        children: [10,11]
    },{
        title: 'Writing React Components',
        depth: 3,
        parentIndex: 9,
        disabled: false,
        content: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec mattis pretium massa. Aliquam erat volutpat. Nulla facilisi. Donec vulputate interdum sollicitudin. Nunc lacinia auctor quam sed pellentesque. Aliquam dui mauris, mattis quis lacus id, pellentesque lobortis odio.',
    },{
        title: 'Composing React Components',
        depth: 3,
        parentIndex: 9,
        disabled: false,
        content: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec mattis pretium massa. Aliquam erat volutpat. Nulla facilisi. Donec vulputate interdum sollicitudin. Nunc lacinia auctor quam sed pellentesque. Aliquam dui mauris, mattis quis lacus id, pellentesque lobortis odio.',
    },{
        title: 'React Components',
        depth: 2,
        parentIndex: 8,
        disabled: true,
        children: [13,14]
    },{
        title: 'Props and State in React',
        parentIndex: 12,
        depth: 3,
        disabled: true,
        content: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec mattis pretium massa. Aliquam erat volutpat. Nulla facilisi. Donec vulputate interdum sollicitudin. Nunc lacinia auctor quam sed pellentesque. Aliquam dui mauris, mattis quis lacus id, pellentesque lobortis odio.',
    },{
        title: 'Component Lifecycle',
        parentIndex: 12,
        depth: 3,
        disabled: true,
        content: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec mattis pretium massa. Aliquam erat volutpat. Nulla facilisi. Donec vulputate interdum sollicitudin. Nunc lacinia auctor quam sed pellentesque. Aliquam dui mauris, mattis quis lacus id, pellentesque lobortis odio.',
    }
]

export {listItems}


/** WEBPACK FOOTER **
 ** ./src/data.js
 **/